import { render } from "./NewUserPrompt.vue?vue&type=template&id=5247a40d&scoped=true&ts=true"
import script from "./NewUserPrompt.vue?vue&type=script&lang=ts"
export * from "./NewUserPrompt.vue?vue&type=script&lang=ts"

import "./NewUserPrompt.vue?vue&type=style&index=0&id=5247a40d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5247a40d"]])

export default __exports__